(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Product-results-pdp"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('prs-slider')) {
  class PrsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-prs-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-prs-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-prs-dot]'));

      if (!this.track || !this.dots.length) return;

      this.raf = null;

      this.onScroll = () => {
        if (this.raf) return;

        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.dotHandlers = this.dots.map((dot, i) => {
        const handler = () => this.go(i);
        dot.addEventListener('click', handler);
        return handler;
      });

      this.update();
    }

    disconnectedCallback() {
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);

      if (this.dots && this.dotHandlers) {
        this.dots.forEach((dot, i) => dot.removeEventListener('click', this.dotHandlers[i]));
      }

      if (this.raf) cancelAnimationFrame(this.raf);
    }

    go(index) {
      const slide = this.slides[index];
      if (!slide) return;

      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    update() {
      const t = this.track;
      let active = 0;

      if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 2) {
        active = this.slides.length - 1;
      } else {
        let min = Infinity;

        this.slides.forEach((slide, i) => {
          const distance = Math.abs(slide.offsetLeft - t.scrollLeft);

          if (distance < min) {
            min = distance;
            active = i;
          }
        });
      }

      this.dots.forEach((dot, i) => {
        const isActive = i === active;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('prs-slider', PrsSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-routien-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var fmt = function (cents, label) { return label + Math.round(cents / 100).toLocaleString('en-US'); };

  function init(root) {
    if (root.dataset.gqReady) return;
    root.dataset.gqReady = '1';

    var q = function (s, c) { return (c || root).querySelector(s); };
    var qa = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
    var fill = function (node, map) {
      Object.keys(map).forEach(function (k) {
        var el = node.querySelector('[data-f="' + k + '"]');
        if (el) el.textContent = map[k];
      });
    };
    var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var data = { routines: [] };
    try { data = JSON.parse(q('[data-gq-data]').textContent); } catch (e) {}

    var label = root.dataset.currency || 'Rs. ';
    var promo = (root.dataset.promo || '').trim();
    var canCapture = root.dataset.capture === 'true';

    var intro = q('[data-gq-intro]'), results = q('[data-gq-results]'), modal = q('[data-gq-modal]');
    var closeBtn = q('[data-gq-close]'), startBtn = q('[data-gq-start]'), bar = q('[data-gq-bar]');
    var steps = qa('[data-gq-q]'), lead = q('[data-gq-lead]'), leadForm = q('[data-gq-form]');
    var skipBtn = q('[data-gq-skip]'), retakeBtn = q('[data-gq-retake]'), errEl = q('[data-gq-error]');
    var tabs = qa('.gq-tier'), totalEl = q('[data-gq-total]'), sumTitle = q('[data-gq-summary-title]');
    var itemsEl = q('[data-gq-items]'), stepsEl = q('[data-gq-steps]');
    var atcBtn = q('[data-gq-atc]'), atcPrice = q('[data-gq-atc-price]');
    var stepTpl = q('[data-gq-step-tpl]'), itemTpl = q('[data-gq-item-tpl]');

    var answers = [], cur = 0, lastFocus = null;
    var routine = null, currentTier = 'core', cartItems = [];

    /* ---------- Quiz navigation ---------- */
    function setStep(i) {
      cur = i;
      steps.forEach(function (s, idx) { s.hidden = idx !== i; });
      lead.hidden = i < steps.length;
      bar.style.transform = 'scaleX(' + Math.min(1, (i + 1) / (steps.length + 1)) + ')';
      var dlg = q('.gq-dialog', modal); if (dlg) dlg.scrollTop = 0;
    }
    function onKey(e) { if (e.key === 'Escape') closeQuiz(); }
    function openQuiz() {
      lastFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      setStep(0);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function closeQuiz() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function resetQuiz() {
      answers = [];
      steps.forEach(function (s) {
        qa('.gq-opt', s).forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        var n = q('[data-gq-next]', s); if (n) n.disabled = true;
        var d = q('.gq-detail', s); if (d) d.hidden = true;
      });
      setStep(0);
    }

    steps.forEach(function (step, qi) {
      var opts = qa('.gq-opt', step);
      var next = q('[data-gq-next]', step), prev = q('[data-gq-prev]', step), over = q('[data-gq-over]', step);
      var box = q('.gq-detail', step);
      var weight = parseInt(step.dataset.weight, 10) || 1;

      opts.forEach(function (btn) {
        var img = btn.dataset.img;
        if (img) btn.addEventListener('pointerenter', function () { (new Image()).src = img; }, { once: true });
        btn.addEventListener('click', function () {
          opts.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
          answers[qi] = {
            weight: weight,
            tags: (btn.dataset.tag || '').toLowerCase().split(',').map(function (t) { return t.trim(); }).filter(Boolean)
          };
          if (next) next.disabled = false;
          if (box) {
            q('.gq-detail-title', box).textContent = btn.dataset.title || '';
            q('.gq-detail-desc', box).textContent = btn.dataset.desc || '';
            var im = q('.gq-detail-img', box);
            if (img) { im.src = img; im.alt = btn.dataset.title || ''; im.hidden = false; } else { im.hidden = true; }
            box.hidden = false;
          }
        });
      });
      if (next) next.addEventListener('click', function () { setStep(qi + 1); });
      if (prev) prev.addEventListener('click', function () { setStep(qi - 1); });
      if (over) over.addEventListener('click', resetQuiz);
    });

    /* ---------- Matching: quiz answers -> routine block ---------- */
    function pickRoutine() {
      var list = data.routines || [];
      if (!list.length) return null;
      var fallback = list.filter(function (r) { return r.isDefault; })[0] || list[0];
      var best = null, bestScore = 0;
      list.forEach(function (r) {
        var set = (r.tags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        var score = 0;
        answers.forEach(function (a) {
          if (a && a.tags.some(function (t) { return set.indexOf(t) > -1; })) score += a.weight;
        });
        if (score > bestScore) { bestScore = score; best = r; }
      });
      return best || fallback;
    }

    /* ---------- Results rendering ---------- */
    function tierList(key) { return (routine && routine.tiers && routine.tiers[key]) || []; }

    function renderTier(key) {
      currentTier = key;
      var list = tierList(key);
      var tierName = '';
      tabs.forEach(function (t) {
        var on = t.dataset.tier === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) tierName = q('.gq-tc-name', t).textContent;
      });

      var sf = document.createDocumentFragment(), itf = document.createDocumentFragment();
      var total = 0; cartItems = [];

      list.forEach(function (p, i) {
        if (p.available) { total += p.price; cartItems.push({ id: p.variant, quantity: 1 }); }
        var priceTxt = p.available ? fmt(p.price, label) : 'Sold out';
        var lab = routine.labels && routine.labels[i];

        var node = stepTpl.content.cloneNode(true);
        fill(node, { tag: 'Step ' + (i + 1) + (lab ? ' | ' + lab : ''), title: p.name, desc: p.tagline, price: priceTxt, timing: p.timing, why: p.why });
        var im = node.querySelector('[data-f="img"]');
        if (p.img) { im.src = p.img; im.alt = p.title; } else { im.remove(); }
        node.querySelector('[data-f="link"]').href = p.url;
        if (!p.why) node.querySelector('.gq-why').remove();
        sf.appendChild(node);

        var row = itemTpl.content.cloneNode(true);
        fill(row, { name: p.title, price: priceTxt });
        itf.appendChild(row);
      });

      stepsEl.textContent = ''; stepsEl.appendChild(sf);
      itemsEl.textContent = ''; itemsEl.appendChild(itf);
      totalEl.textContent = fmt(total, label);
      atcPrice.textContent = fmt(total, label);
      sumTitle.textContent = (root.dataset.summaryTpl || 'Your {tier} Set').replace('{tier}', tierName);
      atcBtn.disabled = !cartItems.length;
    }

    function renderResults() {
      routine = pickRoutine();
      if (!routine) {
        stepsEl.textContent = 'No routines configured yet. Add a "Routine" block in the Theme Editor.';
        return;
      }
      var firstWithItems = null;
      tabs.forEach(function (t) {
        var has = tierList(t.dataset.tier).length > 0;
        t.hidden = !has;
        if (has && !firstWithItems) firstWithItems = t.dataset.tier;
      });
      var want = root.dataset.defaultTier;
      renderTier(tierList(want).length ? want : (firstWithItems || 'core'));
    }

    tabs.forEach(function (t) { t.addEventListener('click', function () { renderTier(t.dataset.tier); }); });

    function finish() {
      closeQuiz();
      renderResults();
      intro.hidden = true;
      results.hidden = false;
      requestAnimationFrame(function () { results.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    }

    /* ---------- Lead capture (non-blocking) ---------- */
    function sendLead(f) {
      var detail = {
        name: f.name.value.trim(), email: f.email.value.trim(), phone: f.phone.value.trim(),
        routine: routine ? routine.title : '', answers: answers.map(function (a) { return a ? a.tags.join('|') : ''; })
      };
      document.dispatchEvent(new CustomEvent('gquiz:lead', { detail: detail }));
      if (!canCapture) return;
      try {
        var body = new URLSearchParams();
        body.append('form_type', 'customer');
        body.append('utf8', '✓');
        body.append('contact[email]', detail.email);
        body.append('contact[first_name]', detail.name);
        if (detail.phone) body.append('contact[phone]', detail.phone);
        body.append('contact[tags]', ['glow-quiz'].concat(answers.reduce(function (acc, a) { return a ? acc.concat(a.tags) : acc; }, [])).join(','));
        fetch(cartRoot + 'contact', { method: 'POST', body: body, keepalive: true, credentials: 'same-origin' }).catch(function () {});
      } catch (e) {}
    }

    leadForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = leadForm.elements;
      var okName = f.name.value.trim().length > 0;
      var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.value.trim());
      f.name.classList.toggle('is-invalid', !okName);
      f.email.classList.toggle('is-invalid', !okEmail);
      if (!okName || !okEmail) {
        errEl.textContent = 'Please enter your name and a valid email, or skip this step.';
        errEl.hidden = false;
        return;
      }
      errEl.hidden = true;
      routine = pickRoutine();
      sendLead(f);
      finish();
    });
    skipBtn.addEventListener('click', finish);

    startBtn.addEventListener('click', function (e) { e.preventDefault(); openQuiz(); });
    closeBtn.addEventListener('click', closeQuiz);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeQuiz(); });
    retakeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      results.hidden = true;
      intro.hidden = false;
      resetQuiz();
      openQuiz();
    });

    /* ---------- 1-click add routine to cart ---------- */
    atcBtn.addEventListener('click', async function () {
      if (!cartItems.length) return;
      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;
      try {
        var res = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: cartItems })
        });
        var json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || 'Error adding routine to cart');

        // Apply the promo code for checkout (tiny JSON response, no page download)
        if (promo) fetch(cartRoot + 'discount/' + encodeURIComponent(promo) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }).catch(function () {});

        atcBtn.classList.remove('is-loading');
        atcBtn.classList.add('is-success');

        var cartEvent = (window._EVENT_HELPER && _EVENT_HELPER.triggerCartChange) || 'action:cart:updateCart';
        document.dispatchEvent(new CustomEvent(cartEvent, {
          bubbles: true,
          detail: { productVariant: json.items && json.items[0] && json.items[0].variant_id, sections: json.sections }
        }));
        document.dispatchEvent(new CustomEvent('gquiz:added', { detail: { items: cartItems, routine: routine && routine.title } }));

        setTimeout(function () {
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer) {
            if (!drawer.isDrawerOpen) {
              var showEvent = (window._EVENT_HELPER && _EVENT_HELPER.showDrawer) || 'action:showDrawer';
              document.dispatchEvent(new CustomEvent(showEvent, { bubbles: true, detail: { drawerType: 'cart-drawer' } }));
            }
          } else {
            window.location.href = cartRoot + 'cart';
          }
        }, 120);

        setTimeout(function () { atcBtn.classList.remove('is-success'); atcBtn.disabled = !cartItems.length; }, 1600);
      } catch (err) {
        atcBtn.classList.remove('is-loading');
        atcBtn.disabled = false;
        alert(err.message || 'Error adding routine to cart.');
      }
    });
  }

  function scan() { document.querySelectorAll('[data-gq-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-benefit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vac-media')) {
    class VacMedia extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-vac-play]');
        if (!this.button) return;
        this.onClick = () => this.load();
        this.button.addEventListener('click', this.onClick, { once: true });
      }

      disconnectedCallback() {
        if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
      }

      load() {
        const template = this.querySelector('template[data-vac-template]');
        const frame = this.querySelector('[data-vac-frame]');
        if (!template || !frame) return;

        frame.replaceChildren(template.content.cloneNode(true));

        const video = frame.querySelector('video');
        if (video) {
          const playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      }
    }
    customElements.define('vac-media', VacMedia);
  }

  /* Theme editor: open an accordion item while its block is selected */
  document.addEventListener('shopify:block:select', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('vac__item')) {
      event.target.open = true;
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('vac__item')) {
      event.target.open = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
